import React, {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import "../styles/CourseContentPage.css";
//import {Document, Page, PDFViewer, Text, View} from '@react-pdf/renderer';
import "../styles/Sidebar.css";
import ReactPlayer from 'react-player/lazy'
import ExamBox from "../components/Exam.jsx";
import CustomPdf from "../components/CustomPdf.tsx";
import {Alert} from "@mui/material";
import Survey from "../components/Survey";
import 'react-circular-progressbar/dist/styles.css';
import FeedbackModal from '../components/FeedbackModal.jsx';
import CourseSidebar from "../components/CourseSidebar";
import Confetti from 'react-confetti';
//import QuestionComparisonReport from "../components/QuestionComparisonReport";
import HtmlToPdfExport from "../components/HtmlToPdfExport";
import "../styles/CourseReportModal.css";


//const YOUTUBE_IFRAME_API = "https://www.youtube.com/iframe_api";

function CourseContentPage() {
    const {courseId} = useParams();
    const [courseContent, setCourseContent] = useState([]);
    const [completedContents, setCompletedContents] = useState([]);
    const [completedContentId, setCompletedContentId] = useState([]);
    const [course, setCourse] = useState([]);
    const [currentContent, setCurrentContent] = useState([]);
    const [currentContentIndex, setCurrentContentIndex] = useState(0);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(false);
    // TODO commented out the because of the unused variables
    const [/*examCompleted*/, setExamCompleted] = useState(true);
    const [exam, setExam] = useState([]);
    const [/*finalScore*/, setFinalScore] = useState(0);
    const [participantId, setParticipantId] = useState(null);
    const [examTakeStatus, setExamTakeStatus] = useState(false);
    const total = courseContent.length;
    const completed = completedContents.length;
    const progress = total > 0 ? Math.round((completed / total) * 100) : 0;
    const isCourseCompleted = total > 0 && completed === total;
    const [isConfettiVisible, setIsConfettiVisible] = useState(false);
    const [showFeedbackButton, setShowFeedbackButton] = useState(false);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const [participantName, setParticipantName] = useState("");

    useEffect(() => {
        if (localStorage.getItem("userEmail")) {
            const getUserName = () => {
                fetch(`${process.env.REACT_APP_API_URL}/students/getByEmail/${localStorage.getItem("userEmail")}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        setParticipantName(`${data.firstName} ${data.lastName}`);
                    })
                    .catch(error => {
                        console.error("Error fetching user data:", error);
                    });
            };

            getUserName();
        }
    }, []);


    useEffect(() => {
        if (isCourseCompleted && !feedbackSubmitted) {
            setShowFeedbackButton(true);
        }
    }, [isCourseCompleted, feedbackSubmitted]);

    const handleFeedbackSubmitted = () => {
        setFeedbackSubmitted(true);
        setShowFeedbackButton(false);
    };

    useEffect(() => {
        if (isCourseCompleted) {
            setIsConfettiVisible(true);
            const timer = setTimeout(() => {
                setIsConfettiVisible(false);
            }, 7000); // 5000 ms = 5 saniye

            return () => clearTimeout(timer); // component unmount edilirse timer temizlenir
        }
    }, [isCourseCompleted]);


    useEffect(() => {
        const setExamStatus = async () => {
            const examTakeStatus = completedContentId.some(
                (content) => content === currentContent.id
            );
            setExamTakeStatus(examTakeStatus);
            //console.log(completedContentId);
            //console.log(currentContent.id);
            //console.log(completedContents);

        }
        setExamStatus().then(r => console.log("exam status set"));

    }, [currentContent, completedContentId]);


    useEffect(() => {
        const fetchParticipantId = async () => {
            const email = localStorage.getItem("userEmail");
            if (!email) {
                alert("Kullanıcı emaili bulunamadı.");
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/course-participants/getByUserEmailAndCourse`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        email: email,
                        courseId: courseId
                    })
                });

                if (response.ok) {
                    const data = await response.json();
                    setParticipantId(data.id);
                    console.log("participant id" + participantId);
                } else {
                    console.error("Participant ID alınamadı");
                }
            } catch (error) {
                console.error("Hata:", error);
            }
        };

        fetchParticipantId().then(() => console.log(participantId));
    }, [courseId, participantId, refreshFlag]);

    const handleQuizFinish = (score, examId) => {
        //console.log("Score:", score);
        //console.log("Exam ID:", examId);
        setExamCompleted(true);
        setFinalScore(score);
        submitExamResult(score, examId).then(r => console.log("Exam result submitted"));
        handleProgress().then(() => console.log("Progress handled for exam"));
    };

    const handleSurveyFinish = (score, examId) => {
        setExamCompleted(true);
        setFinalScore(score);
        //submitExamResult(score, examId).then(r => console.log("Exam result submitted"));
        handleProgress().then(() => console.log("Progress handled for exam"));
    };


    const submitExamResult = async (score, examId) => {
        try {
            const payload = {
                exam_id: examId,
                participant_id: participantId,
                score: score,
                completed_at: new Date().toISOString(),
            };

            const result = await fetch(`${process.env.REACT_APP_API_URL}/exam-results/save`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            //console.log("Exam result payload in save:", payload);

            if (!result.ok) throw new Error('Sunucu hatası');

        } catch (err) {
            console.error(err);
            alert('Sonuç gönderilemedi. Lütfen tekrar deneyin.');
        }
    };

    const fetchCompletedContents = useCallback(async () => {
        try {
            const response = await
                fetch(`${process.env.REACT_APP_API_URL}/course-progress/completed`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                                participantId: participantId,
                                courseId: courseId
                            }
                        )
                    }
                );
            if (response.ok) {
                const data = await response.json();
                setCompletedContents(data);
                setCompletedContentId(data.map(content => content.id));
                setRefreshFlag(prev => !prev); // Listeyi yenile
            } else {
                console.error("Failed to fetch completed contents");
            }
        } catch (error) {
            console.error("Error fetching completed contents:", error);
        }
    }, [participantId, courseId]);


    const fetchExam = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/exams/getByCourse/` + courseId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch data. Status: ${response.status}`);
            }

            const data = await response.json();
            if (data.length > 0) {
                //console.log("Exam data:", data);
                //console.log("content exam id", currentContent?.exam.id);
                //console.log(data[0].id);
                //console.log(currentContent);
                const relatedExam = data.find(e => e.examName === currentContent.title);
                setExam(relatedExam || data[0]);
                //console.log("Exam data:", relatedExam);
                //console.log("Exam data:", data[1]);
                //console.log(currentContent.exam_id);
                console.log(currentContentIndex);
            }
            return data;

        } catch (error) {
            console.error("Error fetching question groups:", error.message);
        }
    }, [courseId, currentContent, currentContentIndex]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courseContents/getByCourseId/` + courseId)
            .then((response) => {
                console.log(response);
                return response.json();
            })
            .then((data) => {
                console.log("Course content data:", data);
                setCourseContent(data);
            })
            .catch((error) => {

                console.error("Error fetching course contents:", error);
            });
    }, [courseId]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courses/getbyid/` + courseId)
            .then((response) => response.json())
            .then((data) => {
                setCourse(data);
            })
            .catch((error) => {
                console.error("Error fetching course contents:", error);
            });
    }, [courseId]);

    useEffect(() => {
        fetchCompletedContents().then(r => console.log("Completed contents fetched"));
        fetchExam().then(() => {
            console.log("Exam fetched");


        });
    }, [fetchCompletedContents, fetchExam, participantId, currentContent]);


    if (!course) {
        return <h2 style={{color: "red"}}>Böyle bir kurs bulunamadı! courseId: {courseId}</h2>;
    }
// await handlecontentchange
    const handleNext = async () => {
        if (currentContentIndex === 0) {
            // activate next button
            setDisableNextButton(false);
            setCurrentContentIndex(1);
            handleContentChange(courseContent[0]);
            return;
        }
        if (currentContentIndex <= courseContent.length - 1) {
            //console.log("Current content index:", currentContentIndex);

            const nextIndex = currentContentIndex + 1;
            const nextContent = courseContent.find(content => content.position === nextIndex);
            //console.log("Next content:", nextContent);
            //console.log("Next index:", nextIndex);

            if (nextContent) {
                if (!await isContentCompleted(currentContent)) {
                    //make post request to update course progress
                    handleProgress().then(r => console.log("progress handled"));
                }
                if (!await isContentCompleted(nextContent)) {
                    // disable next button
                    //setDisableNextButton(true);
                    setDisableNextButton(false);

                }
                handleContentChange(nextContent);
                setCurrentContentIndex(nextIndex);

            } else {
                console.warn("Bir sonraki içerik bulunamadı.");
            }
        }
    }

    const handleVideoEnd = async () => {
        if (currentContentIndex < courseContent.length - 1) {

            // activate next button
            setDisableNextButton(false);
        }

        if (!await isContentCompleted(currentContent)) {
            //make post request to update course progress
            await handleProgress();
        }
        //console.log("Video ended");
    };

    const isContentCompleted = async (content) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/course-progress/content-completed`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                            participantId: participantId,
                            courseId: courseId,
                            courseContentId: content.id
                        }
                    )

                }
            );
            if (response.ok) {
                const data = await response.json();
                return !!data;
            } else {
                console.error("Failed to fetch completed contents");
                return false;
            }
        } catch (error) {
            console.error("Error fetching completed contents:", error);
            return false;
        }
    }

    const handleProgress = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/course-progress/update?participantId=${participantId}&courseContentId=${currentContent.id}&courseId=${courseId}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.ok) {
                alert('İçerik tamamlandı!');
                await fetchCompletedContents();


            } else {
                alert('Tamamlama işlemi başarısız oldu!');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Bir hata oluştu.');
        }
    }
    const handleItemClick = async (content) => {
        // console.log("Clicked content:", content);
        await handleContentChange(content);
    };
    /*
        const handleContentChange = async (content) => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/course-progress/can-access?participantId=${participantId}&courseContentId=${content.id}&courseId=${courseId}`
                );
                if (response.ok) {
                    const canAccess = await response.json();

                    console.log("Can access content:", canAccess);
                    console.log("Content:", content);
                    if (canAccess) {
                        setCurrentContent(content);
                        // if current content position + 1 is in completed contents, enable next button
                        const nextContent = courseContent.find(c => c.position === content.position + 1);
                        if (nextContent && completedContentId.includes(nextContent.id)) {
                            setDisableNextButton(false);
                        }
                        // if current content type is document enable next button
                        if (content.type === "document") {
                            setDisableNextButton(false);

                        }

                        setCurrentContentIndex(content.position);
                    } else {
                        alert("İçeriği tamamlamadan ilerleyemezsiniz!"); // access deny
                    }
                } else {
                    console.error("Error checking content access");
                    alert("Bu içeriğe erişim izniniz yok.");
                }
            } catch (error) {
                console.error("Error checking content access:", error);
                alert("Bir hata oluştu. Lütfen tekrar deneyin.");
            }
        };


    */
    const handleContentChange = (content) => {
        setCurrentContent(content);

        // if current content position + 1 is in completed contents, enable next button
        const nextContent = courseContent.find(c => c.position === content.position + 1);
        if (nextContent && completedContentId.includes(nextContent.id)) {
            setDisableNextButton(false);
        }

        // if current content type is document enable next button
        if (content.type === "document") {
            setDisableNextButton(false);
        }

        setCurrentContentIndex(content.position);
    };

    return (
        <div className="course-content-container">
            {/* Sidebar */}
            <CourseSidebar
                course={course}
                progress={progress}
                courseContent={courseContent}
                completedContents={completedContentId}
                onItemClick={handleItemClick}
                extraData={refreshFlag}
                currentContentIndex={currentContentIndex}
            />





            {/*<div className="sidebar" style={{backgroundColor: "rgb(177,177,181)"}}>
                <h3>{course.name}</h3>

                <div className="sidebar-progress">

                    <h4> Tamamlama Oranı </h4>
                    <div style={{width: 120, height: 120}}>

                        <CircularProgressbar
                            value={progress}
                            text={`${progress}%`}
                            styles={buildStyles({
                                textSize: '16px',
                                pathColor: '#1d34a3',
                                textColor: '#ffffff',
                                trailColor: '#7a8ded'
                            })}
                        />
                    </div>
                </div>

                <VirtualizedList items={courseContent} completedContents={completedContentId}
                                 onItemClick={handleItemClick} extraData={refreshFlag}
                                 currentContentIndex={currentContentIndex}/>

            </div>
            <div style={{textAlign: 'center', position: 'relative'}}>

                {isConfettiVisible && (
                    <Confetti numberOfPieces={300}/>
                )}
            </div>*/}
            {/* Main Content */}
            <div className="content">


                {isCourseCompleted ? (
                    <div className="course-completion-container">
                        {/* Confetti Animation */}
                        {isConfettiVisible && (
                            <Confetti numberOfPieces={300} recycle={false} />
                        )}

                        {/* Completion Card */}
                        <div className="completion-card">
                            <div className="completion-header">
                                <div className="trophy-icon">🏆</div>
                                <h1 className="completion-title">Tebrikler!</h1>
                                <p className="completion-subtitle">
                                    <strong>{course.name}</strong> kursunu başarıyla tamamladınız!
                                </p>
                                <div className="completion-date">
                                    <span className="date-icon">📅</span>
                                    <span>{new Date().toLocaleDateString('tr-TR', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}</span>
                                </div>
                            </div>

                            <div className="completion-stats">
                                <div className="stat-item">
                                    <div className="stat-icon">📚</div>
                                    <div className="stat-text">
                                        <span className="stat-number">{total}</span>
                                        <span className="stat-label">İçerik Tamamlandı</span>
                                    </div>
                                </div>
                                <div className="stat-item">
                                    <div className="stat-icon">⭐</div>
                                    <div className="stat-text">
                                        <span className="stat-number">100%</span>
                                        <span className="stat-label">Başarı Oranı</span>
                                    </div>
                                </div>
                                <div className="stat-item">
                                    <div className="stat-icon">🎯</div>
                                    <div className="stat-text">
                                        <span className="stat-number">{participantName}</span>
                                        <span className="stat-label">Kurs Tamamlayan</span>
                                    </div>
                                </div>
                            </div>

                            <div className="completion-actions">
                                {/* Sertifika Butonu */}
                                <button
                                    className="action-btn certificate-btn"
                                    onClick={() => {
                                        // Sertifika görüntüleme fonksiyonu
                                        window.open(`${process.env.REACT_APP_API_URL}/certificates/generate/${participantId}/${courseId}`, '_blank');
                                    }}
                                >
                                    <span className="btn-icon">🏅</span>
                                    <span className="btn-text">Sertifikamı Görüntüle</span>
                                    <span className="btn-arrow">→</span>
                                </button>

                                {/* Rapor Butonu */}
                                <button
                                    className="action-btn report-btn"
                                    onClick={() => setShowReport((prev) => !prev)}
                                >
                                    <span className="btn-icon">📊</span>
                                    <span className="btn-text">{showReport ? "Raporu Gizle" : "Gelişim Raporunu Görüntüle"}</span>
                                    <span className="btn-arrow">{showReport ? "↑" : "↓"}</span>
                                </button>

                                {/* Değerlendirme Butonu */}
                                {showFeedbackButton && (
                                    <button
                                        className="action-btn feedback-btn"
                                        onClick={() => setShowFeedbackModal(true)}
                                    >
                                        <span className="btn-icon">⭐</span>
                                        <span className="btn-text">Kursu Değerlendir</span>
                                        <span className="btn-arrow">→</span>
                                    </button>
                                )}
                            </div>

                            {/* Motivational Quote */}
                            <div className="completion-quote">
                                <div className="quote-icon">💡</div>
                                <p className="quote-text">
                                    "Öğrenme, asla durmayan bir yolculuktur. Tebrikler, bu önemli adımı attığınız için!"
                                </p>
                            </div>

                            {/* Rapor Modal */}
                            {showReport && (
                                <div className="modal-overlay">
                                    <div className="modal-box wide">
                                        <button onClick={() => setShowReport(false)} className="close-button">
                                            ✕
                                        </button>
                                        <HtmlToPdfExport
                                            participantId={participantId}
                                            courseId={courseId}
                                            onClose={() => setShowReport(false)}
                                            courseName={course.name}
                                            participantName={participantName}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Feedback Modal */}
                            <FeedbackModal
                                isOpen={showFeedbackModal}
                                onClose={() => setShowFeedbackModal(false)}
                                studentId={participantId}
                                courseId={courseId}
                                onFeedbackSubmitted={handleFeedbackSubmitted}
                            />
                        </div>
                    </div>
                ) : (
                    <div>

                            {currentContent.type === "video" ? (
                                    <div>
                                        <div className="video-container" style={{
                                            width: '100%',
                                            maxWidth: '-webkit-fill-available',
                                            height: '70%',
                                            maxHeight: '-webkit-fill-available',
                                            padding: '5%'
                                        }}>
                                            <ReactPlayer url={currentContent.url} controls={false} onEnded={handleVideoEnd}
                                                         style={
                                                             {
                                                                 marginTop: "20px",
                                                                 margin: "auto",
                                                                 width: "100%",
                                                                 height: "100%",
                                                             }
                                                         }/>


                                        </div>
                                        <Alert variant="outlined" severity="info" style={{width: '70%', marginLeft: '17%'}}>Videoya
                                            çift
                                            tıklayarak tam ekran görüntüleyebilirsiniz.</Alert>
                                        <Alert variant="outlined" severity="info" style={{width: '70%', marginLeft: '17%'}}>Fareyi
                                            video
                                            üzerinde sağa sola hareket ettirerek 3 boyutlu izleme deneyimi
                                            yaşayabilirsiniz.</Alert>
                                    </div>
                                )
                                :
                                currentContent.type === "document" ? (

                                    <div className="document-container" style={{
                                        width: 'fit-content',
                                        maxWidth: '-webkit-fill-available',
                                        height: '100%',
                                        maxHeight: '-webkit-fill-available'
                                    }}>
                                        {/*TODO: Custom PDF Usage With All Features*/}
                                        <CustomPdf src={currentContent.url} showDownload={false} showPrint={false}
                                                   renderTextLayer={false} extraData={refreshFlag}/>

                                    </div>
                                ) : currentContent.type === "exam" && exam ? (
                                    <div>

                                        <ExamBox
                                            onFinish={(score, examId) => handleQuizFinish(score, examId)}
                                            exam={exam}
                                            participantId={participantId}
                                            extraData={refreshFlag}
                                            examTakeStatus={examTakeStatus}

                                        />


                                    </div>
                                ) : currentContent.type === "survey" && exam ? (

                                    <div>
                                        {examTakeStatus ? (
                                            <div style={{
                                                textAlign: "center",
                                                width: "600px",
                                                height: "200px",
                                                margin: "auto"
                                            }}>
                                                <h2 style={{marginTop: "250px"}}>Anket daha önce çözülmüş</h2>
                                            </div>
                                        ) : (
                                            <Survey
                                                onFinish={handleSurveyFinish}
                                                survey={exam}
                                                participantId={participantId}
                                            />
                                        )}

                                    </div>
                                ) : (
                                    <div>
                                        <h3 align='center'> {course.name}</h3>
                                        <p align='center'>
                                            {course.description}
                                        </p>
                                        <p align='center'>
                                            Başlamak için bir ders seç
                                        </p>
                                    </div>

                                )}


                            <button className="next-button" onClick={handleNext} disabled={disableNextButton}>
                                {currentContentIndex === 0 ? "Başla" : "İleri"}
                            </button>

                        </div>
                    )}

                {isConfettiVisible && (
                    <Confetti numberOfPieces={300}/>
                )}
            </div>
        </div>
    );
}

export default CourseContentPage;
